import { Column } from "@faire/web/slate/Layout";
import { LoadingSkeleton } from "@faire/web/slate/LoadingSkeleton";
import { Spacer } from "@faire/web/slate/spacing";
import React from "react";

export const ProductTileLoadingSkeleton: React.FC<{
  className?: string;
}> = ({ className }) => {
  return (
    <Column className={className} data-test-id="product-tile-placeholder">
      <LoadingSkeleton width="100%" height="" aspectRatio="1" />
      <Column className="flex-1 py-4">
        <Spacer height={4} />
        <LoadingSkeleton width="100%" height="16px" />
        <Spacer height={4} />
        <LoadingSkeleton width="75%" height="16px" />
        <Spacer height="1x" />
        <Spacer height={4} />
        <Spacer height={{ mobileAndAbove: "8x", tabletAndAbove: "5x" }} />
      </Column>
    </Column>
  );
};
